import React from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Button,
  Row,
  Col,
} from "reactstrap";
import CoreEngine from "../../core/CoreEngine";
import RequestEngine from "../../core/RequestEngine";
import { connect } from "react-redux";
import loadingAction from "../../core/redux/actions/loadingAction";
import ReactTable from "react-table";
import TablePagination from "components/Table/TablePagination";
import strings from "../../core/translate";
import RowActions, {
  editAction,
  deleteAction,
} from "components/Table/RowActions";
import SelectRow from "../../components/Select/SelectRow";
import { Scopes } from "../../shared/scopes.enum";

class VehicleModelTrimsList extends CoreEngine {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      dataSource: [],
      makes: [],
      models: [],
      selectedMake: "",
      selectedModel: "",
      globalFilter: "",
      startDateFilter: null,
      endDateFilter: null,
      canWrite: false,
    };
    this.engine = new RequestEngine();
  }

  componentDidMount() {
    this.fetchmakes();
    const { selectedMake, selectedModel } =
      this.props.location.state || this.props.match.params;
    const canWrite = this.hasPermission([Scopes.VEHICLES_MAKES_WRITE]);
    this.setState({ canWrite });

    if (selectedMake) {
      this.setState({ selectedMake }, () => {
        this.fetchmodels(); // Load the models for the selected make
      });
    }

    if (selectedModel) {
      this.setState({ selectedModel }, () => {
        this.callPage(); // Load the trims for the selected model
      });
    }
  }

  fetchmakes = async () => {
    const response = await this.engine.getItem("vehicles");
    if (response && response.status === 200) {
      this.setState({
        isLoading: false,
        makes: response.data.items.map((make) => ({
          value: make.id,
          label: make.name,
        })),
      });
    }
  };
  async fetchmodels() {
    const { selectedMake, selectedModel } = this.state;
    if (!selectedMake) return;
    const response = await this.engine.getItem(
      `vehicles/${selectedMake}/models`
    );
    if (response && response.status === 200) {
      if (selectedModel !== ":selectedModel")
        this.setState({
          models: response.data.items.map((model) => ({
            value: model.id,
            label: model.name,
          })),
        });
      else
        this.setState({
          models: response.data.items.map((model) => ({
            value: model.id,
            label: model.name,
          })),
          selectedModel: "",
        });
    }
  }

  async callPage() {
    const { selectedModel } = this.state;
    if (!selectedModel || selectedModel === ":selectedModel") return;

    const pathname = `vehicles-models/${selectedModel}/trims`;
    const response = await this.engine.getItem(pathname);
    if (response && response.status === 200) {
      this.setState({
        isLoading: false,
        dataSource: response.data.items.map((item, key) => ({
          id: key,
          data: item,
          name: item.name,
          model: item.model.name,
          created: new Date(item.createdAt),
          actions: this.handleActions(key, item),
        })),
      });
    }
    this.props.loadingAction(false);
  }

  handlePage() {
    this.props.loadingAction(true);
    this.callPage();
  }

  async handleDelete(valueid) {
    if (window.confirm(strings.confirmdelete)) {
      this.props.loadingAction(true);
      const { selectedModel } = this.state;
      const result = await this.engine.deleteItem(
        `vehicles-models/${selectedModel}/trims`,
        valueid
      );
      if (result) {
        this.handlePage();
      }
      this.props.loadingAction(false);
    }
  }

  handleActions(index, item) {
    return (
      <RowActions
        actions={[
          editAction(() => this.handleEdit(index, item.id), this.state.canWrite),
          deleteAction(() => this.handleDelete(item.id), this.state.canWrite),
        ]}
      />
    );
  }
  handlemakeselect(event) {
    const selectedMake = event.value;

    if (selectedMake !== this.state.selectedMake)
      this.setState(
        { selectedMake, selectedModel: "", models: [], dataSource: [] },
        () => {
          this.fetchmodels(); // Fetch models for the selected make
        }
      );
  }

  handlemodelselect(event) {
    const selectedModel = event.value;
    this.setState({ selectedModel }, () => {
      this.props.history.push(`/admin/vehicles_models/${selectedModel}/trims`);
      this.callPage(); // Fetch trims for the selected model
    });
  }

  handleAdd() {
    const { selectedMake, selectedModel } = this.state;

    if (!selectedMake || selectedMake === ":selectedMake") {
      alert(`${strings.select} ${strings.make}`);
      return;
    }

    if (!selectedModel || selectedModel === ":selectedModel") {
      alert(`${strings.select} ${strings.model}`);
      return;
    }

    // Push the selectedMake and selectedModel to the history
    this.props.history.push({
      pathname: `/admin/vehicles_models/${selectedModel}/trims/add`,
      state: { selectedMake, selectedModel },
    });
  }

  handleEdit(index, dataid) {
    const data = this.state.dataSource[index].data;
    const { selectedMake, selectedModel } = this.state;
    if (!selectedMake || selectedMake === ":selectedMake") {
      alert(`${strings.select} ${strings.make}`);
      return;
    }
    if (!selectedModel || selectedModel === ":selectedModel") {
      alert(`${strings.select} ${strings.model}`);
      return;
    }

    // Push the selectedMake and selectedModel along with the data to the history
    this.props.history.push({
      pathname: `/admin/vehicles_models/${selectedModel}/trims/edit/${dataid}`,
      state: { selectedMake, selectedModel },
      data,
    });
  }

  render() {
    const {
      dataSource,
      isLoading,
      makes,
      models,
      selectedMake,
      selectedModel,
      canWrite,
    } = this.state;

    let columns = [
      { Header: strings.name, accessor: "name" },
      { Header: strings.model, accessor: "model" },
      {
        Header: strings.created,
        accessor: "created",
        Cell: (row) => row.value.toLocaleDateString(),
      },
      {
        Header: strings.actions,
        accessor: "actions",
        sortable: false,
        filterable: false,
      },
    ];

    return (
      <>
        <div className="content">
          <Row>
            <Col md="12">
              <Card>
                <CardHeader>
                  <CardTitle tag="h4" className="pull-left"></CardTitle>
                  {canWrite && (
                    <Button
                      color="primary"
                      className="pull-right"
                      onClick={() => this.handleAdd()}
                    >
                      {strings.add}
                    </Button>
                  )}
                  <SelectRow
                    label={strings.make}
                    name="selectedMake"
                    defaultValue={selectedMake}
                    data={makes}
                    changeInput={(e) => this.handlemakeselect(e)}
                    placeholder={strings.select}
                  />
                  <SelectRow
                    key={selectedMake || "default"}
                    label={strings.model}
                    name="selectedModel"
                    defaultValue={selectedModel}
                    data={models}
                    changeInput={(e) => this.handlemodelselect(e)}
                    placeholder={strings.select}
                    viewonly={!selectedMake}
                  />
                </CardHeader>
                <CardBody>
                  <ReactTable
                    previousText={strings.previous}
                    nextText={strings.next}
                    loadingText={strings.loading}
                    noDataText={strings.nodata}
                    pageText={strings.page}
                    data={dataSource}
                    defaultFilterMethod={this.filterCaseInsensitive}
                    filterable
                    loading={isLoading}
                    columns={columns}
                    defaultPageSize={10}
                    showPaginationTop={false}
                    showPaginationBottom
                    PaginationComponent={TablePagination}
                    className="-striped -highlight primary-pagination"
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  loadingAction: (payload) => dispatch(loadingAction(payload)),
});
export default connect(null, mapDispatchToProps)(VehicleModelTrimsList);
